import { ChangeDetectionStrategy, Component } from '@angular/core'
import { ActivatedRoute } from '@angular/router'

@Component({
  selector: 'ftr-help-page',
  template: '<ftr-help [isLoggedIn]="isLoggedIn" />',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HelpPage {
  isLoggedIn = this.route.snapshot.data?.isLoggedIn

  constructor(private route: ActivatedRoute) {}
}
